import { RootStackScreenComponent } from 'src/navigation'

export const MoreModulesScreen: RootStackScreenComponent<'MoreModules'> = () => {
  return <></>
}
